"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var runOnEnter = function runOnEnter() {
  for (var _len = arguments.length, handlers = Array(_len), _key = 0; _key < _len; _key++) {
    handlers[_key] = arguments[_key];
  }

  return function (nextState, replaceState, cb) {
    return _promise2.default.all(handlers.map(function (handler) {
      return new _promise2.default(function (resolve) {
        return handler(nextState, replaceState, resolve);
      });
    })).then(function () {
      return cb();
    }).catch(cb);
  };
};

exports.default = runOnEnter;